<template>
	<div>
		<div>
			<!--最新活动-->
			<div class="text-left">
				<div class="jumbotron jumbotron_bb t_20" style="padding-bottom: 20px;">
					<div class="container" style="padding-bottom: 10px;">
						<div class="row">
							<div class="col-2 middle" style="margin-left:-20px;margin-right:20px;margin-top:5px"
								@click="auto(models.imgages_1)">
								<div class="is">{{aoto_text}}</div>

							</div>
							<div class="col-10">
								<h5>{{models.title}}</h5>
								<div>{{models.label}}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 	<vue-audio style="width: 100%;"
				    audio-source="https://img.hsnms.com/20211130/1638282313.mp3"
				  ></vue-audio> -->

				<div style="padding-bottom: 10px;">
					<img style="width: 100%;" :src="models.imgages_b">
				</div>


				<div>
					<h4>内容介绍</h4>
					<div class="row">
						<div class="col-12" style="text-indent:2em; font-size: 15px; line-height: 35px;">
							<samp v-html="models.detailed"></samp>
						</div>
					</div>
				</div>

			</div>
			<div style="height: 30px;"></div>
		</div>



	</div>
	</div>
</template>

<script>
	let audio = new Audio()
	export default {
		data() {
			return {
				v_url: "https://img.hsnms.com/20211130/1638282313.mp3",
				show: false,
				aoto_bo: false,
				aoto_text: "播放",
				models: {}
			}
		},
		methods: {
			sel(id) {
				this.$api.getAPI("data/info/" + id + "?type_id=20201109&state=1", {}).then(
					res => {
						console.log(res.data.data.models);
						this.models = res.data.data.models;
					})
				// var oAudio = document.getElementById("music");
				// oAudio.src = "https://img.hsnms.com/20211130/1638282313.mp3";
				// oAudio.play();
			},
			auto(url) {
				//播放声音
				if (url.length < 5) {
					this.aoto_text = "暂无"
					return
				}
				if (this.aoto_bo == false) {
					this.aoto_text = "暂停"
					this.aoto_bo = true
					audio.src = url;
					audio.play();
				}else{
					this.aoto_text = "播放"
					this.aoto_bo = false
					audio.pause();
				}
			},
		},
		mounted() {
			var id = this.$route.query.id;
			this.sel(id);
		}
	}
</script>

<style scoped>
	.jumbotron_bb {
		width: 100%;
		height: 100px;
		padding: 20px 20px !important;
		background-image: url("https://img.hsnms.com/20211201/1638365595.jpg") !important;
		background-size: 100% 100%;
		background-position: center center;
		color: #fff;
		/* background: #3480fa; */
	}

	.input-group input {
		border: 1px solid #ccc;
		padding-left: 12px;
	}

	.label-primary {
		color: #3480fa;
		background-color: #dcdfe6;
	}

	.label_50 {
		border-radius: 50px/50px;
	}

	.i2 {
		position: absolute;
		right: 30px;
		top: 106px;
		font-size: 25px !important;
	}

	.ic2 {
		position: absolute;
		right: 30px;
		top: 112px;
		font-size: 18px !important;
		color: #ffd986;
	}

	.i3 {
		position: absolute;
		right: 25px;
		top: 56px;
		font-size: 25px !important;
	}

	.ic3 {
		position: absolute;
		right: 25px;
		top: 60px;
		font-size: 18px !important;
		color: #ffd986;
	}

	.pop {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
	}

	.edit {
		display: flex;
		flex-direction: column;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 300px;
		height: 300px;
		background: #fff;
		z-index: 990;
		overflow: hidden;
		border-radius: 20px;
		padding: 10px 20px;
		box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
	}

	.edit h4 {
		margin: 0;
	}


	.container-fluid-a {
		position: absolute;
		top: 50px;
	}

	.is {
		width: 50px;
		text-align: center;
		line-height: 50px;
		height: 50px;
		font-size: 14px;
		border: 1px solid #c0c0c0;
	}

	.jumbotron {
		margin-bottom: 20px;
		border-radius: 0rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/web/bwg/show_voice.vue